import { Component, EventEmitter, OnInit, Output, OnDestroy } from '@angular/core';
import { timer, scan, takeWhile, asyncScheduler, Subscription } from 'rxjs';
import { SharedModule } from '../shared.module';
import { Router } from '@angular/router';
import { ApiDataService } from '../../services/api.service';

@Component({
    selector: 'app-re-login',
    imports: [SharedModule],
    templateUrl: './re-login.component.html',
    styleUrl: './re-login.component.scss'
})
export class ReLoginComponent implements OnInit, OnDestroy{
  @Output() destroy = new EventEmitter;
  counter!: Subscription;
  result$ = timer(0, 1000).pipe(
    scan(ticks => --ticks, 60),
    takeWhile(v => v >= 0)
  );
  countDown: number = 60;
  labels: any;
  currentLob: string = '';
  refreshToken: string = '';
  private startTime!: number;
  private intervalId: any;

  constructor(
    private router: Router,
    private _apiService: ApiDataService
  ){
    this.currentLob = sessionStorage.getItem('currentLob') || '';
    this.refreshToken = sessionStorage.getItem('refresh-token') || '';
  }

  ngOnInit(): void {
    this.startTime = Date.now();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.startTimer();
    this.labels = JSON.parse(sessionStorage.getItem('labels') as any);
    

    this.counter = this.result$.subscribe(x => {
      // this.countDown = x;
      // if(this.countDown === 0){
      //   this.destroy.emit(true);
      //   this.router.navigate(["/"]);
      // }
    });
   
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  startTimer() {
    this.intervalId = setInterval(() => {
      // Logic that will be throttled
      const elapsedTime = Date.now() - this.startTime;

      
      this.countDown = 60 - Math.floor(elapsedTime / 1000);
      this.countDown -= 1;
      if(this.countDown < 0){
        this.destroy.emit(true);
        this.router.navigate(["/"]);
      }
    }, 1000);
  }

  handleVisibilityChange = () => {
    if (!document.hidden) {
      const actualElapsedTime = Date.now() - this.startTime;
    }
  }

  validate(){
    const PAYLOAD = {
      token: this.refreshToken
    }
    this._apiService.refreshToken(PAYLOAD).subscribe((x) => {
      sessionStorage.setItem('token', x.newAccessToken);
      this.counter.unsubscribe();
      this.destroy.emit(true);
    }, (error) => {
    });
  }

}
